import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getSmsCode } from "../../logic/utils";
import { getCommonParamsFromState } from "../../utils";
import { getCommonSubmitPayment } from "../logic.common";
import { sbpPaymentRequest } from "./api";
import { getPollSbp } from "./api/poll.sbp";
export var getSendSbpPayment = function getSendSbpPayment(_ref) {
  var getUserAccountInfo = _ref.getUserAccountInfo,
    isSmsResend = _ref.isSmsResend,
    getContent = _ref.getContent;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(getState, setState) {
      var state, _getUserAccountInfo, accountNumber, _getCommonParamsFromS, sum, to, bindingId;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            state = getState();
            _getUserAccountInfo = getUserAccountInfo(), accountNumber = _getUserAccountInfo.accountNumber;
            if (accountNumber) {
              _context2.next = 4;
              break;
            }
            throw new Error('not authenticated');
          case 4:
            _getCommonParamsFromS = getCommonParamsFromState(state, accountNumber, true), sum = _getCommonParamsFromS.sum, to = _getCommonParamsFromS.to, bindingId = _getCommonParamsFromS.bindingId;
            if (bindingId) {
              _context2.next = 7;
              break;
            }
            throw new Error('no binding id provided');
          case 7:
            return _context2.abrupt("return", getCommonSubmitPayment({
              submit: function () {
                var _submit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var _yield$sbpPaymentRequ, status, payId;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return sbpPaymentRequest({
                          to: to,
                          amount: sum,
                          bindingId: bindingId,
                          smsCode: getSmsCode(state, isSmsResend)
                        });
                      case 2:
                        _yield$sbpPaymentRequ = _context.sent;
                        status = _yield$sbpPaymentRequ.status;
                        payId = _yield$sbpPaymentRequ.payId;
                        return _context.abrupt("return", {
                          status: status !== null && status !== void 0 ? status : undefined,
                          orderId: "".concat(payId)
                        });
                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                function submit() {
                  return _submit.apply(this, arguments);
                }
                return submit;
              }(),
              pollStatus: getPollSbp(accountNumber),
              getContent: getContent
            })(getState, setState));
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};